import React from 'react';
import PlanPrice from './PlanPrice';
import PlanActions from './PlanActions';
import PlanDetails from './PlanDetails';

const PlanBoxItem = props => {
  const { plan, name, planClass, description, button, sliders, showPrice, subtitle } = props;

  return (
    <div className={`plan-box ${planClass}`} data-plan={plan}>
      <div className="plan-box-inner">
        <div className="plan-header">
          <h3 className={`plan-title ${subtitle}`}>{name}</h3>
          <div className="plan-image">
            <img src={`/pages/ab-variants/new-pricing/img/illustration-${plan}.svg`} alt={plan} />
          </div>
        </div>
        <div className="plan-body">
          {plan !== 'enterprise' && <PlanPrice />}
          {plan === 'enterprise' &&
            <h2 className="ent-alt-text">
              Contact Us
            </h2>}
          {plan !== 'enterprise' && <PlanDetails plan={plan} sliders={sliders} />}
          {plan === 'enterprise' &&
            <p className="plan-description">
              {description}
            </p>}
          <PlanActions button={button} />
          <div className="js-plan-features-container" data-plan={plan} />
        </div>
      </div>
    </div>
  );
};

export default PlanBoxItem;



// WEBPACK FOOTER //
// ./src/components/pricingPlans/components/planBox/PlanBoxItem.js